import {createRouter, createWebHistory} from 'vue-router'
import Layout from "@/layout/index.vue";
import {
    getConfigApi,
    getDomainApi,
    getJsonData,
    getOssListApi,
    getProvinceOssListApi,
    getUserBaseInfo
} from "@/utils/untils";
import {useInfoStore} from "@/store";
import {isTeacher, verificationTime} from "@/utils/publicMethonds.js";
import {ElMessage, ElMessageBox} from "element-plus";
import {editBaseRouter} from "@/views/editBase/editBase.js";
import {checkPageList, checkPermissions} from "@/utils/permissions.js";
import request from "@/utils/request.js";

const routes = [
    {
        path: '/',
        name: 'Admin',
        redirect: '/home',
        component: Layout,
        meta: {
            title: '升学规划系统'
        },
        children: [
            {
                path: '/home',
                name: 'home',
                component: () => import(/* webpackChunkName: "about" */ '@/views/home/index.vue'),
                meta: {
                    title: '升学规划系统'
                },
            },
            {
                path: "/weici",
                component: () => import("@/views/yifenyidang/index.vue"),
                name: "位次",
            },
            {
                path: "/pici",
                component: () => import("@/views/picixian/index.vue"),
                name: "批次",
            },
            {
                path: "/intention",
                component: () => import("@/views/personal/index.vue"),
                name: "intention",
                meta: {
                    title: '我的志愿'
                },
            },
            {
                path: "/ai_list",
                component: () => import("@/views/personal/ai_list.vue"),
                name: "ai_list",
                meta: {
                    title: 'AI工作台'
                },
            },
            {
                path: "/personal",
                component: () => import("@/views/personal/personal.vue"),
                name: "Personal",
                meta: {
                    title: '个人中心'
                },
            },
            {
                path: "/tools",
                component: () => import("@/views/tools/index.vue"),
                name: "tools",
                meta: {
                    title: '高考工具箱'
                },
            },
            {
                path: "/news",
                component: () => import("@/views/tools/news.vue"),
                name: "news",
                meta: {
                    title: '高考资讯'
                },
            },
            {
                path: "/profession",
                component: () => import("@/views/profession/index.vue"),
                name: "Profession",
            },
            {
                path: "/subject",
                component: () => import("@/views/subject/index.vue"),
                name: "Subject",
            },
            {
                path: "/university",
                component: () => import("@/views/university/index.vue"),
                name: "University",
            },
            {
                path: "/chose_batch",
                component: () => import("@/views/chose_batch/chose_batch.vue"),
                name: "ChoseBatch",
                meta: {
                    title: '选择批次'
                },
            },
            {
                path: "/set_report_info",
                component: () => import("@/views/chose_batch/SetReportInfo.vue"),
                name: "SetReportInfo",
                meta: {
                    title: '设置报告信息'
                },
            },
            {
                path: "/set_report_list",
                component: () => import("@/views/chose_batch/SetReportList.vue"),
                name: "SetReportList",
                meta: {
                    title: '设置报告信息'
                },
            },
            {
                path: '/buy_report_times',
                name: 'BuyReportTimes',
                component: () => import("@/views/BuyReportTimes.vue"),
                meta: {
                    title: '选志愿'
                },
            },
            {
                path: '/assess_info',
                name: 'Assess_Info',
                component: () => import("@/views/ChoseMajor.vue"),
                meta: {
                    title: 'AI选专业'
                },
            },
            {
                path: '/subject_analysis',
                name: 'SubjectAnalysis',
                component: () => import('@/views/ChoseSubject.vue'),
                meta: {
                    title: '高一选科'
                },
            },
            {
                path: '/goods',
                name: 'Goods',
                component: () => import(/* webpackChunkName: "about" */ '@/views/Goods.vue'),
                meta: {
                    title: '开通VIP'
                },
            },
            {
                path: '/school_info',
                name: 'SchoolInfo',
                component: () => import(/* webpackChunkName: "about" */ '@/views/university/index.vue'),
                meta: {
                    title: '学校详情'
                },
            },
            {
                path: '/article_info',
                name: 'ArticleInfo',
                component: () => import(/* webpackChunkName: "about" */ '@/views/university/article.vue'),
                meta: {
                    title: '详情'
                },
            },
            {
                path: '/aiTool',
                name: 'aiTool',
                component: () => import(/* webpackChunkName: "about" */ '@/components/tools/AITool.vue'),
                meta: {
                    title: 'AI工具'
                },
            },
            {
                path: '/choseVolunteer',
                name: 'choseVolunteer',
                component: () => import(/* webpackChunkName: "about" */ '@/views/volunteer/choseVolunteer.vue'),
                meta: {
                    title: '选志愿',
                    tabCard: '/chose_batch'
                },
            },
            {
                path: '/volunteerDetail',
                name: 'volunteerDetail',
                component: () => import(/* webpackChunkName: "about" */ '@/views/volunteer/volunteerDetail.vue'),
                meta: {
                    title: '我的志愿',
                    tabCard: '/intention'
                },
            },
            {
                path: '/AIWorkBench',
                name: 'AIWorkBench',
                component: () => import(/* webpackChunkName: "about" */ '@/views/volunteer/AIWork/AIWorkbench.vue'),
                meta: {
                    title: 'AI工作台',
                    tabCard: '/ai_list'
                },
            },
            {
                path: '/preBatch',
                name: 'preBatch',
                component: () => import(/* webpackChunkName: "about" */ '@/views/volunteer/preBatch/index.vue'),
                meta: {
                    title: '提前批',
                },
            },
            {
                path: '/landing',
                name: 'landing',
                component: () => import(/* webpackChunkName: "about" */ '@/views/landing/index.vue'),
                meta: {
                },
            },
            {
                path: '/pre',
                name: 'pre',
                component: () => import(/* webpackChunkName: "about" */ '@/views/editBase/pre.vue'),
                meta: {
                    title: '升学规划系统'
                },
            },
        ]
    },

    {
        path: '/school_map',
        name: 'SchoolMap',
        component: () => import(/* webpackChunkName: "about" */ '@/views/SchoolMap.vue'),
        meta: {
            title: '地理位置'
        },
    },
    {
        path: '/mini_program_sharing',
        name: 'MiniProgramSharing',
        component: () => import('@/views/tools/MiniProgramSharing/index.vue'),
        meta: {
            title: '小程序分享',
        }
    },
    ...editBaseRouter

]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    // history: createWebHistory(),
    routes
})
const backFn = async () => {
    const version = await getJsonData({url: 'cache/v'})
    localStorage.setItem('json_v', version?.json_v)
    localStorage.setItem('currentV', version?.v)
    localStorage.setItem('time_v', version?.time_v)
    const provinceId = localStorage.getItem('provinceId')
    const res = await getDomainApi();
    await getOssListApi();
    await getConfigApi(res?.domain);
    if (provinceId && provinceId!=0){
        await getProvinceOssListApi();
    }
}
const verifyCall = async (to,form) => {
    try {

        if (to.path === '/editBaseInfo' && process.env.NODE_ENV!='development'){
            const userInfo = (await getUserBaseInfo())?.data?.data
            if (userInfo.provinceId){
                return Promise.reject()
            }
        }
        if (to.path === '/editScore'){
            const userInfo = (await getUserBaseInfo())?.data?.data
            const flag = await  request.post({
                url: `user/verifyHighReportingPeriod/${userInfo.provinceId}`,
            })
            if (userInfo.modify_score_times<1 || (flag && userInfo.vip_level == 60)){
                return Promise.reject()
            }
        }
        const current = checkPageList.find(item => item.path.toLocaleLowerCase() === to.path.toLocaleLowerCase())
        if (current) {
            await checkPermissions({infos: to})
            const userInfo = useInfoStore().baseInfo;
            if (to.path === '/choseVolunteer' && (userInfo.disableVip)) {
                const str = userInfo.disableVip == 1 ? '正式报考期间:体验用户的vip相关功能不可用' : userInfo.disableVip == 2 ? '正式报考期间非当年考生的vip相关功能不可用' : ''
                await ElMessageBox.alert(str, '提示', {
                    confirmButtonText: '确定',
                })
                return Promise.reject()
            }
        }
        return Promise.resolve()
    } catch (e) {
        return Promise.reject()
    }

}
router.beforeEach((to, from, next) => {
    const userInfo = useInfoStore();

    backFn().then(async () => {
        try {
            const isTeacherLogin = isTeacher();
            const unLogin = !(verificationTime()) && localStorage.getItem('jwt');
            const isAllowedRoute = to.name === 'home' || to.name === 'news';
            if (localStorage.getItem('jwt') && to.name!='login'){
                const flag = localStorage.getItem('bindPhone')
                if (flag&&!Number(flag)){
                    next({path: '/login',query:{
                            bind:1
                        }})
                }else {
                    if (isAllowedRoute) {
                        await verifyCall(to,from)
                        next();
                    } else if (!unLogin && isTeacherLogin) {
                        next({name: 'home'});
                        userInfo.setKey('showTeacherLogin', true);
                    } else {
                        await verifyCall(to,from)
                        next();
                    }
                }
            }else {
                if (isAllowedRoute) {
                    await verifyCall(to,from)
                    next();
                } else if (!unLogin && isTeacherLogin) {
                    next({name: 'home'});
                    userInfo.setKey('showTeacherLogin', true);
                } else {
                    await verifyCall(to,from)
                    next();
                }
            }


        } catch (e) {
            const flag = userInfo?.backType
            if (flag){
                next({name: 'pre'});
            }else {
                next({name: 'home'});
            }
        }
    })
})

export default router
